import React, { useEffect, useState } from "react";
import { getallStock } from "services/api";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import ReportDetails from "../ReportDetails";
import {
  getEntriesAndExits,
  getManipulatedData,
  getTotalStockCounts,
} from "../StockCahierHelper";
import StockReportTable from "./StockReportTable";

const StockReportDetails = () => {
  const [stockDetails, setStockDetails] = useState([]);
  const [reportData, setReportData] = useState([]);

  const getStockDetails = async () => {
    const res = await getallStock();
    setStockDetails(res.data || res);
    // setCahierData(res.data);
  };
  useEffect(() => {
    var o = getManipulatedData(stockDetails, "seed");
    const res = getEntriesAndExits(o, "entries", "exits");
    setReportData(res);
  }, [stockDetails]);
  useEffect(() => {
    getStockDetails();
  }, []);
  const reportTabContent = (item) => {
    const filterData = reportData.filter((data) => data.key === item.label);
    const counts = getTotalStockCounts(
      filterData[0]?.value?.entries,
      filterData[0]?.value?.exits
    );
    return (
      <>
        {filterData?.length ? (
          <div className="box-set">
            <Grid>
              <Box sx={{ flexGrow: 3 }} className="stockReportSection">
                <Card className="card" style={{ display: "flex" }}>
                  <table className="resumeTabels" style={{ width: "100%" }}>
                    <tr>
                      <th>
                        <CardContent>
                          {" "}
                          <Typography
                            sx={{ fontSize: 16, color: "#373737" }}
                            color="text.secondary"
                            gutterBottom
                          >
                            Entrees
                          </Typography>
                          <Typography
                            className="data-tabel"
                            sx={{ mb: 1.5, fontSize: 14, color: "#979797" }}
                            color="text.secondary"
                          >
                            {filterData[0]?.value?.entries.map((entry) => (
                              <span> {`${entry.origin}, `}</span>
                            ))}
                          </Typography>
                        </CardContent>
                      </th>
                      <th>
                        <CardContent>
                          <Typography
                            sx={{ fontSize: 16, color: "#373737" }}
                            color="text.secondary"
                            gutterBottom
                          >
                            Sorties
                          </Typography>
                         
                            <Typography
                              className="data-tabel"
                              sx={{ mb: 1.5 }}
                              color="text.secondary"
                            >
                               {filterData[0]?.value?.exits.map((exit) => (
                              <span>
                              {`${exit.destination},`}
                              </span>
                               ))} 
                            </Typography>
                         
                        </CardContent>
                      </th>
                      <th>
                        <CardContent>
                          <Typography
                            sx={{ fontSize: 16, color: "#373737" }}
                            color="text.secondary"
                            gutterBottom
                          >
                            Solde
                          </Typography>
                        </CardContent>
                      </th>
                    </tr>
                    <tbody>
                      <tr>
                        <td>
                          <CardContent>
                            <Typography
                              className="qnt-data"
                              variant="body2"
                            >{`${counts.entries.kg} kg`}</Typography>
                            <Typography
                              className="cfa-data"
                              variant="body2"
                            >{`${counts.entries.cfa} CFA`}</Typography>
                          </CardContent>
                        </td>
                        <td>
                          <CardContent>
                            <Typography
                              className="qnt-data"
                              variant="body2"
                            >{`${counts.exits.kg} kg`}</Typography>
                            <Typography
                              className="cfa-data gfgfgfgf"
                              variant="body2"
                            >{`${counts.exits.cfa} CFA`}</Typography>
                          </CardContent>
                        </td>
                        <td>
                          <CardContent>
                            <Typography
                              className="data-tabel qnt-data"
                              variant="body2"
                            >{`${counts.total.kg}kg`}</Typography>
                            <Typography
                              className="data-tabel cfa-data"
                              variant="body2"
                            >{`${counts.total.cfa}CFA`}</Typography>
                          </CardContent>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <CardContent>
                    {/* <Typography
                      sx={{ fontSize: 16, color: "#373737" }}
                      color="text.secondary"
                      gutterBottom
                    >
                      Entrees
                    </Typography>
                    {filterData[0]?.value?.entries.map((entry) => (
                      <Typography
                        className="data-tabel"
                        sx={{ mb: 1.5, fontSize: 14, color: "#979797" }}
                        color="text.secondary"
                      >
                        {`${entry.origin}, `}
                      </Typography>
                    ))} */}
                    {/* <Typography
                      className="qnt-data"
                      variant="body2"
                    >{`${counts.entries.kg} kg`}</Typography>
                    <Typography
                      className="cfa-data"
                      variant="body2"
                    >{`${counts.entries.cfa} CFA`}</Typography> */}
                  </CardContent>

                  <CardContent>
                    {/* <Typography
                      sx={{ fontSize: 16, color: "#373737" }}
                      color="text.secondary"
                      gutterBottom
                    >
                      Sorties
                    </Typography> */}
                    {/* {filterData[0]?.value?.exits.length ? (
                      filterData[0]?.value?.exits.map((exit) => (
                        <Typography
                          className="data-tabel"
                          sx={{ mb: 1.5 }}
                          color="text.secondary"
                        >
                          {`${exit.destination}, `}
                        </Typography>
                      ))
                    ) : (
                      <p style={{ opacity: "0", marginBottom: "30px" }}>
                        no data
                      </p>
                    )} */}
                    {/* <div>
                      <Typography
                        className="qnt-data"
                        variant="body2"
                      >{`${counts.exits.kg} kg`}</Typography>
                      <Typography
                        className="cfa-data"
                        variant="body2"
                      >{`${counts.exits.cfa} CFA`}</Typography>
                    </div> */}
                  </CardContent>

                  <CardContent>
                    {/* <Typography
                      sx={{ fontSize: 16, color: "#373737" }}
                      color="text.secondary"
                      gutterBottom
                    >
                      Solde
                    </Typography> */}
                    {/* <Typography
                      className="data-tabel cfa-data"
                      variant="body2"
                    >{`${counts.total}CFA`}</Typography> */}
                  </CardContent>
                </Card>
              </Box>
            </Grid>
            {Object.keys(filterData[0]?.value).map((option) => (
              <StockReportTable
                tableName={option}
                rows={filterData[0].value[option]}
              />
            ))}
          </div>
        ) : (
          <div className="no_datas">
            <p>No Record Found</p>
          </div>
        )}
      </>
    );
  };

  return (
    <ReportDetails
      backUrl={"/stock-report"}
      title={"Stock"}
      reportData={reportData}
      reportTabContent={reportTabContent}
    />
  );
};

export default StockReportDetails;
